<template>
  <v-app>
    <v-main>
      <v-container fluid>
        <v-row align="center" justify="center" outlined align-content="center">
          <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-12 mx-auto">
              <v-card-title>Sorry {{ givenName }}, you can't access that area.</v-card-title>
              <v-card-text>
                <div v-if="signedIn">
                  <p>Contact the sys admin to get your account's permissions elevated</p>
                  <p>
                    Once extra permissions have been granted you will need to log out and
                    log back in again.
                  </p>
                  <p>Please provide the following information when making your request</p>

                  <ul>
                    <li>Username: {{ username }}</li>
                    <li>Your Groups: {{ userGroups }}</li>
                    <li>Requested page: {{ redirect }}</li>
                  </ul>
                </div>
                <div v-else>
                  <p>
                    Your credentials are unable to be authenticated. Please contact the sys
                    admin
                  </p>
                </div>
              </v-card-text>
              <v-card-actions>
                <v-btn to="/" left>Back to Home</v-btn>
                <v-spacer />
                <v-btn right to="/login" color="primary">Login</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import Vue from "vue";

export default {
  async created() {
    await this.getUser();
    this.redirect = this.$route.query.redirect;
  },
  data() {
    return {
      checkedAuth: false,
      signedIn: false,
      username: "",
      givenName: "",
      redirect: "",
      userGroups: [],
    };
  },
  methods: {
    getUser: async function () {
      {
        try {
          const user = await Vue.prototype.$Amplify.Auth.currentAuthenticatedUser();
          if (user && user.signInUserSession) {
            //console.log("getUser got user");
            this.checkedAuth = true;
            this.signedIn = true;
            this.username = user.username;
            this.givenName = user.attributes["given_name"] ?? "";
            this.userGroups =
              user?.signInUserSession?.accessToken?.payload["cognito:groups"] ??
              [];
          } else {
            console.log("getUser user invalid");
            this.checkedAuth = true;
            this.signedIn = false;
            this.username = "";
            this.givenName = "";
            this.userGroups = [];
          }
        } catch (err) {
          console.log("getUser err", err);
          this.checkedAuth = true;
          this.signedIn = false;
          this.username = "";
          this.givenName = "";
          this.userGroups = [];
        }
      }
    },
  },
};
</script>
